import { useMsal } from '@azure/msal-react';
import { Stack } from '@mui/system';
import React from 'react';

const loginRequest = {
    scopes: ['User.Read']
};

const MicrosoftLoginButton = ({ handleSuccess = () => {} }) => {
    const { instance, accounts } = useMsal();

    const handleLogin = () => {
        instance
            .loginPopup(loginRequest)
            .then((data) => handleSuccess(data))
            .catch((e) => {
                console.error(e);
            });
    };

    return (
        <button
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                position: 'relative',
                alignItems: 'center',
                marginTop: '0px',
                paddingTop: '0px',
                backgroundColor: 'white',
                borderRadius: '2px',
                cursor: 'pointer',
                border: '1px solid #DADCE0',
                padding: '8px 16px'
            }}
            id="btn-google"
            onClick={handleLogin}
        >
            <Stack display="flex" direction="row" alignItems="flex-start" justifyContent="center">
                <div className="btn-logo" style={{ position: 'absolute', left: 12 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <g clipPath="url(#clip0_3368_2675)">
                            <path d="M7.60413 7.60413H0V0H7.60413V7.60413Z" fill="#F1511B" />
                            <path d="M16.0005 7.60413H8.39648V0H16.0005V7.60413Z" fill="#80CC28" />
                            <path d="M7.60394 15.9987H0V8.39453H7.60394V15.9987Z" fill="#00ADEF" />
                            <path d="M16.0005 15.9987H8.39648V8.39453H16.0005V15.9987Z" fill="#FBBC09" />
                        </g>
                        <defs>
                            <clipPath id="clip0_3368_2675">
                                <rect width="16" height="16" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <span className="btn-text">Sign in with Microsoft</span>
            </Stack>
        </button>
    );
};

export default MicrosoftLoginButton;
